import axiosClient, { responseBody } from '@/api/axios-client';

export interface Reward {
  slug: string;
  title: string;
  description: string;
  payout: { sparks?: number; xp?: number };
  progress: number;
  target: number;
  completed: boolean;
  claimed: boolean;
}

export const getRewards = () => {
  return axiosClient
    .get<{ rewards: Reward[] }>('/api/rewards')
    .then(responseBody);
};

export const claimReward = (slug: string) => {
  return axiosClient
    .post(`/api/rewards/${slug}/claim`)
    .then(responseBody);
};

export const markPopupsSeen = (slugs: string[]) => {
  return axiosClient
    .post('/api/rewards/popups/seen', { slugs })
    .then(responseBody);
};
